<template>
    <div>
        <!-- Begin:PageContent:Main -->
        <section id="content" class="image-bg3">
            <div class="container">
                <div class="row">
                    <!-- Begin:Content-FlightSearchTabs-Booking -->
                    <div id="main" class="col-sm-8 col-md-9">
                        <sdr-shared-flightsearch-tabs modulo="services"></sdr-shared-flightsearch-tabs>
                    </div>
                    <!-- Begin:Content-FlightSearchTabs-Booking -->


                    <!-- Begin:Content-SideBar-Direct -->
                    <div class="sidebar col-sm-4 col-md-3">
                        <sdr-promobox-direkt></sdr-promobox-direkt>
                    </div>
                    <!-- End:Content-SideBar-Direct -->
                </div>
            </div>
        </section>
        <!-- End:PageContent:Main -->

        <!-- Begin:Content:FlightSearchResults -->
        <sdr-shared-flightsearchresults modulo="services"></sdr-shared-flightsearchresults>
        <!-- End:Content:FlightSearchResults -->

        <!-- Begin:Content:BookingnoOverview -->
        <sdr-services-bookingnooverview modulo="services"></sdr-services-bookingnooverview>
        <!-- End:Content:BookingnoOverview -->
    </div>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import FlightSearchResults from '../shared/flightsearch/FlightSearchResults.vue'; // Content (shared)
    import BookingnoOverview from '../services/pagecontent/BookingnoOverview.vue'; // Services only

    import PromoBoxDirect from '../shared/sidebar/Banner1.vue';

    import { mapGetters } from 'vuex';
    import { eventBus } from '../../main';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-shared-flightsearchresults': FlightSearchResults,
            'sdr-services-bookingnooverview': BookingnoOverview,

            'sdr-promobox-direkt': PromoBoxDirect,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                alertmessage: {
                    en: 'Info: Dear passenger, here you can only reserve seats and book services after you already have a confirmed flight booking.',
                    de: 'Info: Sehr geehrter Fluggast, hier können Sie ausschließlich Sitzplätze reservieren und Services buchen, nachdem Sie bereits im Besitz einer bestätigten Flugbuchung sind.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn'
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> booking/passengers/Passenger.vue >>> created');
            eventBus.$on('agencyhasloggedin', this.onEmit_AgencyHasLoggedin);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> booking/passengers/Passenger.vue >>> beforeDestroy');
            eventBus.$off('agencyhasloggedin', this.onEmit_AgencyHasLoggedin);

        }, // eo function beforeDestroy()
        /* >>> *************************************************************** /  /* LifeCycles */



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_AgencyHasLoggedin()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_AgencyHasLoggedin: function(type) {

                let me = this;


                me.$toc('>>> services/Home.vue >>> onEmit_AgencyHasLoggedin');
                me.$router.push({ path: '/' });

            }, // eo function onEmit_AgencyHasLoggedin()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-help {
        background: #dcecf6;
        color: #406f8c;
        margin-left: 15px;
        margin-right: 15px;
    }
    .alert .close,
    .info-box .close {
        color: #406f8c;
    }
</style>